import { Title, Flex } from '@mantine/core';

import { UsersTable, UsersFilter, useGetUsers } from '@/modules/users';

export const Users = () => {
  const {
    params,
    items: users,
    itemsCount: usersCount,
    isLoading,
    handleFilterChange,
    handleFilterReset,
    handlePaginationChange,
  } = useGetUsers();

  return (
    <>
      <Flex justify="space-between" align="center" w="100%" mb={10}>
        <Title order={4}>Пользователи</Title>
      </Flex>

      <UsersFilter
        onSubmit={handleFilterChange}
        onReset={handleFilterReset}
      />

      <UsersTable
        items={users}
        isLoading={isLoading}
        itemsCount={usersCount}
        pageSize={params.pageSize}
        currentPage={params.page}
        onPageChange={handlePaginationChange}
      />
    </>
  );
};
